import { useLocation } from 'react-router';
import { getSubCategoryFromPath } from '../../../../../../common/utils/employeeUtils.js';
import { EoeSubscriptionPairingScene } from '../../../../../../components/EoeSubscriptionPairingScene/EoeSubscriptionPairingScene.js';
import { useAuth } from '../../../../AuthProvider.js';

export const EoeDeviceAddPath = () => {
  const { authenticatedUser } = useAuth();
  const { pathname } = useLocation();
  const category = getSubCategoryFromPath(pathname);

  return <EoeSubscriptionPairingScene mdmId={authenticatedUser?.mdmId || ''} category={category} />;
};
